/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Suggestions_LabelInputs */



/**
* | output |
* | --- |
* | "Follow-up Suggestions" |
*
* @param {Preferences_Suggestions_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_suggestions_label = /** @type {((inputs?: Preferences_Suggestions_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Suggestions_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Folgefragen-Vorschläge")
	return /** @type {LocalizedString} */ ("Follow-up Suggestions")
});